import {HTMLAttributes, useState} from 'react'
import _ from 'lodash'
import {IFieldDescriptor} from '../..'
import {IMixerChannel, IMixerChannelProps, MixerChannel} from './channel'
import {InitViewTemplate, InitViewTemplateIDs, InitViewTemplates} from './init-views'
import './style.css'

export interface IMixerChannelCollectionProps extends HTMLAttributes<HTMLDivElement> {
  // defaultChannelValue?: IMixerChannel['value'],
  channels?: IMixerChannel[]
  actions?: React.ReactElement
  channelProps?: Partial<IMixerChannelProps>
  simplified?: boolean
  canDelete?: boolean
  // extraTemplateOptions?: IChannelTemplateSelectorProps['extraOptions'],
  onChannelsChanged?: (channels: IMixerChannel[]) => void
}

export function MixerChannelCollection(props: IMixerChannelCollectionProps) {
  const {
    // defaultChannelValue,
    channels,
    actions,
    channelProps,
    simplified,
    canDelete,
    // extraTemplateOptions,
    onChannelsChanged,
    ...rest
  } = {
    canDelete: true,
    ...props,
  }

  const [soloChannels, setSoloChannels] = useState<{[key: string]: boolean} | undefined>(undefined)

  function handleOnDelete(channel: IMixerChannel) {
    if (!onChannelsChanged) return
    onChannelsChanged(
      _.chain(channels)
        .without(channel)
        .forEach((c) => {
          c.value.solo = undefined
          c.value.mute = undefined
        })
        .value()
    )
    setSoloChannels(undefined)
  }

  // TODO: use channel components hook merge
  function handleOnChanged(
    i: number,
    value: Partial<{
      descriptor: Partial<IFieldDescriptor>
      data: Partial<IMixerChannel['value']>
    }>
  ) {
    const {descriptor, data} = value
    if (!onChannelsChanged) return
    if (i === -1) return
    if (!channels) return
    const channel = channels[i]
    const newChannelState: IMixerChannel = {
      ...channel,
      descriptor: {
        ...channel.descriptor,
        ...descriptor,
      },
      value: {
        ...channel.value,
        ...data,
      },
    }
    if (_.isEqual(newChannelState, channel)) return

    // solo
    if (_.has(newChannelState.value, 'solo')) {
      setSoloChannels((prev) => {
        const res = _.chain({
          ...prev,
          [newChannelState.descriptor.sourcePath]: newChannelState.value.solo || false,
        })
          .toPairs()
          .filter(([, v]) => v)
          .fromPairs()
          .value()
        if (_.keys(res).length === 0) return
        return res
      })
    }

    onChannelsChanged([..._.slice(channels, 0, i), newChannelState, ..._.slice(channels, i + 1)])
  }

  const classNames = _.chain(['channel-collection', simplified ? 'simplified' : undefined])
    .compact()
    .join(' ')
    .value()

  return (
    <div
      className={classNames}
      {...rest}
    >
      {_.map(channels, (c, i) => (
        <MixerChannel
          key={`${c.descriptor.sourcePath}-${i}`}
          simplified={simplified}
          {...channelProps}
          {...c}
          {...(soloChannels !== undefined && !_.has(soloChannels, c.descriptor.sourcePath) ?
            {
              value: {
                ...c.value,
                mute: true,
              },
              disableMute: true,
            }
          : undefined)}
          onDelete={canDelete ? () => handleOnDelete(c) : undefined}
          onChanged={(data) => handleOnChanged(i, data)}
        />
      ))}
      {actions ? actions : null}
    </div>
  )
}

export type {IMixerChannel, IMixerChannelProps, InitViewTemplate, InitViewTemplateIDs}
export {InitViewTemplates}
